export default __webpack_public_path__ + "static/nick-headshot-2ad674e00a2527a78936009ee78c79ea.jpg";